import React from 'react';
// used for making the prop types of this component
import PropTypes from 'prop-types';

// core components
// import Button from 'components/CustomButtons/Button.jsx';
import Fab from '@material-ui/core/Fab';
import DeleteIcon from '@material-ui/icons/Delete';
import defaultImage from 'assets/img/image_placeholder.jpg';
import defaultAvatar from 'assets/img/placeholder.jpg';
// import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogTitle from '@material-ui/core/DialogTitle';

class PreviewVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      file: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage,
    };
  }
  fileInput = React.createRef();

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleRemove = () => {
    this.setState({
      file: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage,
    });
    this.fileInput.current.value = null;
  };
  render() {
    var { imageProps,removeButton } = this.props;
    return (
      <div>
        {/* <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            {'Video'}
          </DialogTitle>
          <DialogContent>
            {imageProps &&
              <video width="100%" controls>
                <source src={imageProps} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="danger" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog> */}
        <div className="fileinput text-center" style={{position:'relative'}}>
          <div
            className={'thumbnail'}
            style={{
              maxWidth: '100%',
              padding: '5px',
              backgroundColor: '#eeeeee',
            }}
            // onClick={this.handleClickOpen}
            >
            {imageProps &&
              <video width="100%" controls>
                <source src={imageProps} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              // <img width="100%" src={imageProps} alt="..." />
            }
          </div>
          <div>
            {(imageProps && removeButton) && (
              <Fab style={{position:'absolute',top:-20,right:-20}} color="secondary" aria-label="delete" onClick={() => this.props.handleRemove()}>
                <DeleteIcon />
              </Fab>
            )}
          </div>
        </div>
      </div>
    );
  }
}

PreviewVideo.propTypes = {
  removeButton: PropTypes.bool,
  removeButtonProps: PropTypes.object,
  imageProps: PropTypes.string,
};

export default PreviewVideo;
